/**
 * Same rules as `shop/client/src/config/storefrontHost.js`.
 * When `REACT_APP_STOREFRONT_HOST` is omitted, `normalizeHostInner('')` yields `modamai.com`, so
 * `X-Store-Host` pins to the apex Moda MAI tenant (matches working shop/client builds).
 */

export const CANONICAL_STORE_HOST = normalizeHostInner(
  process.env.REACT_APP_CANONICAL_STORE_HOST || 'modamai.com',
);

export const MODAMAI_CANONICAL_STORE_HOST = CANONICAL_STORE_HOST;

function normalizeHostInner(host) {
  if (!host || typeof host !== 'string') return 'modamai.com';
  return host
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    .split(':')[0]
    .toLowerCase()
    .trim();
}

export function resolveStorefrontHostHeader() {
  let explicit = normalizeHostInner(process.env.REACT_APP_STOREFRONT_HOST || '');
  if (
    explicit === 'localhost' ||
    explicit === '127.0.0.1' ||
    /^127\.\d+\.\d+\.\d+$/.test(explicit)
  ) {
    explicit = '';
  }

  if (explicit) return explicit;

  if (typeof window === 'undefined') {
    return CANONICAL_STORE_HOST;
  }

  const hostname = window.location.hostname.toLowerCase();

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return CANONICAL_STORE_HOST;
  }

  if (hostname.endsWith('.netlify.app') || hostname.endsWith('.vercel.app')) {
    return CANONICAL_STORE_HOST;
  }

  return window.location.host.toLowerCase();
}
